module.exports = __webpack_public_path__ + "img/authentication-ico02@2x.fc6bfb1f.png";